// @flow
/**
 * User: Mike Chung
 * Date: 20/1/2018
 * Time: 8:03 PM
 */
import type {
    CloseEBadgeUnlockModalAction,
    EBadgeUnlockFailedAction, EBadgeUnlockStartAction, EBadgeUnlockSuccessAction, EBadgeUnlockThunkAction,
    OpenEBadgeUnlockModalAction
} from "../eBadgeUnlockAction";
import {unlockEBadge} from "../../../dao/eBadgeDao";
import type {StoreState} from "../../../reducers/combinedReducers";
import type {Caller} from "../../../components/QueryPage";


function eBadgeUnlockStartAction(registrationCode: string): EBadgeUnlockStartAction {
    return {
        type: "ebadge/UNLOCK_START_ACTION",
        registrationCode: registrationCode
    };
}

function eBadgeUnlockSuccessAction(registrationCode: string): EBadgeUnlockSuccessAction {
    return {
        type: "ebadge/UNLOCK_SUCCESS_ACTION",
        registrationCode: registrationCode
    }
}

function eBadgeUnlockFailedAction(error: any, registrationCode: string): EBadgeUnlockFailedAction {
    return {
        type: "ebadge/UNLOCK_FAILED_ACTION",
        registrationCode: registrationCode,
        error: Object.assign({}, error)
    }
}

export function eBadgeUnlockAction(registrationCode: string, caller: Caller): EBadgeUnlockThunkAction {

    return async (dispatch, getState: ?() => StoreState) => {
        try {

            if (getState) {

                let state = getState();
                dispatch(eBadgeUnlockStartAction(registrationCode));
                await unlockEBadge(registrationCode, caller, state.loginUser.jwt);
                dispatch(eBadgeUnlockSuccessAction(registrationCode));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {
            dispatch(eBadgeUnlockFailedAction(e, registrationCode));
        }
    };
}

export function openUnlockEBadgeModalAction(registrationCode: string): OpenEBadgeUnlockModalAction {
    return {
        type: "ebadge/SHOW_UNLOCK_MODAL",
        registrationCode: "" + registrationCode
    }
}

export function closeUnlockEBadgeModalAction(): CloseEBadgeUnlockModalAction {
    return {
        type: "ebadge/HIDE_UNLOCK_MODAL"
    }
}


// WEBPACK FOOTER //
// ./src/actions/ebadge/creators/eBadgeUnlockActionCreator.js